// extracted by mini-css-extract-plugin
module.exports =  {"DashboardReminder":"DashboardReminder__5SHYS"};